import React from 'react'

const WaitListIcon = () => {
    return (
        <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.357 13.4763C11.7319 12.8512 10.884 12.5 9.99996 12.5H4.99996C4.1159 12.5 3.26806 12.8512 2.64294 13.4763C2.01782 14.1014 1.66663 14.9493 1.66663 15.8333V17.5" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.49996 9.16667C9.34091 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34091 2.5 7.49996 2.5C5.65901 2.5 4.16663 3.99238 4.16663 5.83333C4.16663 7.67428 5.65901 9.16667 7.49996 9.16667Z" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.3334 9.16667L15 10.8333L18.3334 7.5" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

        </div>
    )
}

export default WaitListIcon